export const REASON_CODE = '*';